// src/components/Plasticization.js
import React from 'react';
import injectImg from '../../../imgs/Plasticizat.webp'; 
import './Plasticization.css';

const Plasticization = () => {
  return (
    <div className="plastic-container">
      <div className="plastic-text"data-aos="flip-down">
        <h2>INJECTION SYSTEM</h2>
        <ul>
          <li>High Precision</li>
          <li>More Stable</li>
          <li>Good Plasticization</li>
        </ul>
        <p>
          High rigidity integral linear guide low friction, improve the accuracy of injection.
          Long life-time double carriage movement cylinders.
        </p>
      </div>
      <div className="plastic-image">
        <img src={injectImg} alt="Injection System" />
      </div>
    </div>
  );
};

export default Plasticization;
